module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-76x76-6d60c3e529fa0c845158718544197c2a.png";